import type { Payment, PaymentStatus } from "@/types";

export interface ClientPaymentSummary {
  payments: Payment[];
  totalReceived: number;
  totalPending: number;
  totalOverdue: number;
  count: number;
}

export function getPaymentDetailPath(paymentId: string): string {
  return `/payments/${paymentId}`;
}

export function getPaymentNotePeriod(payment: Pick<Payment, "period" | "note">): {
  primary: string;
  secondary?: string;
} {
  if (payment.period) {
    return { primary: payment.period, secondary: payment.note };
  }
  if (payment.note) return { primary: payment.note };
  return { primary: "-" };
}

export function buildPaymentStatusUpdate(status: PaymentStatus): { status: PaymentStatus } {
  return { status };
}

export function summarizeClientPayments(current: Payment, payments: Payment[]): ClientPaymentSummary {
  const byClient = payments.filter((payment) => payment.clientId === current.clientId);
  const history = byClient.some((payment) => payment.id === current.id) ? byClient : [current, ...byClient];
  return {
    payments: history.slice(0, 6),
    totalReceived: history.filter((payment) => payment.status === "RECEIVED").reduce((sum, payment) => sum + payment.amount, 0),
    totalPending: history.filter((payment) => payment.status === "PENDING").reduce((sum, payment) => sum + payment.amount, 0),
    totalOverdue: history.filter((payment) => payment.status === "OVERDUE").reduce((sum, payment) => sum + payment.amount, 0),
    count: history.length,
  };
}
